import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import "../styles.css";

export default function Stream() {
  return (
    <>
      <SEO
        title="Live Stream"
        description="Watch ZeMaxi live on Twitch, YouTube, and Kick! Multi-streaming gaming content with different experiences per platform. Pure gameplay on YouTube, interactive fun on Twitch & Kick."
        keywords="ZeMaxi Twitch, ZeMaxi YouTube, ZeMaxi Kick, live stream, multi-streaming, gaming stream, watch live, stream schedule, subscriber perks, channel points"
        url="https://zemaxi.com/stream"
      />
      <Navbar />
      <main>
        <section className="stream-hero">
          <div className="container">
            <h1>Live <span className="highlight">Stream</span></h1>
            <p>Multi-streaming on Twitch, YouTube & Kick - Choose your viewing experience!</p>
          </div>
        </section>
        <section className="stream-section">
          <div className="container">
            <div className="stream-container">
              <div className="offline-message">
                <i className="fas fa-broadcast-tower"></i>
                <h2>Currently <span className="highlight">Offline</span></h2>
                <p>I'm not streaming right now, but check out the schedule below to see when I'll be back!</p>
                <p>In the meantime, you can watch my <a href="/videos">previous videos</a> or explore my <a href="/shop">streaming tools</a>.</p>
              </div>
              <div className="stream-platforms">
                <h2>Watch <span className="highlight">Live</span></h2>
                <div className="platform-links">
                  <a href="https://twitch.tv/zemaxi" target="_blank" rel="noopener noreferrer" className="platform-btn twitch-btn">
                    <i className="fab fa-twitch"></i> Twitch
                    <span className="platform-desc">Interactive Experience</span>
                  </a>
                  <a href="https://youtube.com/@zemaxi/live" target="_blank" rel="noopener noreferrer" className="platform-btn youtube-btn">
                    <i className="fab fa-youtube"></i> YouTube
                    <span className="platform-desc">1440p HDR Pure Gameplay</span>
                  </a>
                  <a href="https://kick.com/zemaxi" target="_blank" rel="noopener noreferrer" className="platform-btn kick-btn">
                    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" className="kick-icon">
                      <path d="M37 .036h164.448v113.621h54.71v-56.82h54.731V.036h164.448v170.777h-54.73v56.82h-54.711v56.8h54.71v56.82h54.73V512.03H310.89v-56.82h-54.73v-56.8h-54.711v113.62H37V.036z" fill="currentColor"/>
                    </svg> Kick
                    <span className="platform-desc">Interactive Experience</span>
                  </a>
                  <div className="platform-btn tiktok-btn" aria-disabled="true">
                    <i className="fab fa-tiktok"></i> TikTok
                    <span className="platform-desc coming-soon">Coming Soon</span>
                  </div>
                </div>
              </div>

              <div className="stream-info">
                <h2>About My <span className="highlight">Stream</span></h2>
                <p>I multi-stream on <strong>Twitch</strong>, <strong>YouTube</strong>, and <strong>Kick</strong> - each platform offers a different viewing experience!</p>

                <div className="platform-comparison">
                  <h3>🎬 <span className="highlight">YouTube</span> - Pure Gameplay Experience</h3>
                  <p>Watch in the best quality at 1440p with HDR support without any distractions. No overlays, no alerts, no memes - just clean gameplay and my commentary. Perfect if you want to experience the game as intended.</p>

                  <h3>🎮 <span className="highlight">Twitch & Kick</span> - Interactive Fun</h3>
                  <p>Join the full interactive experience! Gameplay with overlays, channel point redeems, meme sounds, alerts, and all the community chaos. This is where the fun happens - redeem channel points, trigger sounds, and be part of the stream!</p>
                </div>

                <h3>What to Expect:</h3>
                <ul>
                  <li><strong>Gaming:</strong> I primarily play action RPGs, adventure, and the occasional indie title. While focusing on story games, I tend to not respond to messages during cutscenes or dialogues.</li>
                  <li><strong>Tool Development:</strong> While still learning coding, I enjoy creating tools for OBS and Streamer.bot. You can find them in the <a href="/shop"><span className="highlight">shop</span></a>.</li>
                  <li><strong>Chat Interaction:</strong> You'll sometimes hear a "Citizen" sound alert when someone chats. This helps me to know when someone joins in first time as I do tend to get distracted with the game I am playing.</li>
                </ul>
                <p>If you enjoy the stream, consider following or subscribing to support future content!</p>
              </div>

                            <div className="stream-features">
                <h2 className="features-title">Stream Features &<span className="highlight"> Subscriber Benefits</span></h2>
                <div className="features-grid">
                  <div className="feature-card">
                    <div className="feature-header">
                      <i className="fas fa-gem feature-icon" style={{color: '#ffb400'}}></i>
                      <h3>Channel Points</h3>
                    </div>
                    <p>Redeem channel points for fun on-stream interactions, sound effects, memes, and more!</p>
                  </div>
                  <div className="feature-card">
                    <div className="feature-header">
                      <i className="fas fa-laugh-squint feature-icon" style={{color: '#ff5e57'}}></i>
                      <h3>Fun Commands</h3>
                    </div>
                    <p>Trigger meme sounds and alerts live on stream. Have fun with the community and surprise me!</p>
                  </div>
                  <div className="feature-card">
                    <div className="feature-header">
                      <i className="fas fa-star feature-icon" style={{color: '#00eaff'}}></i>
                      <h3>Sub Perks</h3>
                    </div>
                    <p>Get Ad-free viewing, Exclusive emotes & badges, save up Channel Points by using Sub-only commands to play memes and access to all of my Premium tools!</p>
                  </div>
                  <div className="feature-card">
                    <div className="feature-header">
                      <i className="fa-solid fa-gamepad feature-icon" style={{color: '#a259f7'}}></i>
                      <h3>Gameplay</h3>
                    </div>
                    <p>I live life in Hard mode, but I play in Easy mode. Perfectly balanced!</p>
                  </div>
                </div>
              </div>
              <div className="stream-schedule">
                <h2>Stream <span className="highlight">Schedule</span></h2>
                <p>Below is my stream schedule, please note that this is subject to change due to commitments with work and personal life.</p>
                <div className="schedule-grid">
                  <div className="schedule-item">
                    <div className="schedule-day">Tuesday</div>
                    <div className="schedule-game">Watch Dogs 2</div>
                    <div className="schedule-time">6:00PM (UK)</div>
                  </div>
                  <div className="schedule-item">
                    <div className="schedule-day">Thursday</div>
                    <div className="schedule-game">Watch Dogs 2</div>
                    <div className="schedule-time">6:00PM (UK)</div>
                  </div>
                  <div className="schedule-item">
                    <div className="schedule-day">Saturday</div>
                    <div className="schedule-game">Watch Dogs 2</div>
                    <div className="schedule-time">10:00AM (UK)</div>
                  </div>
                </div>
              </div>

              <div className="stream-setup">
                <h2>My <span className="highlight">Streaming Setup</span></h2>
                <p>Here's the gear and software I use to bring you the best streaming experience:</p>

                <div className="setup-grid">
                  <div className="setup-category">
                    <h3>🎮 <span className="highlight">Gaming</span></h3>
                    <ul>
                      <li><strong>Console:</strong> PlayStation 5 Pro, Nintendo Switch, PlayStation 3</li>
                      <li><strong>PC:</strong> Razer Blade 17 Pro (2020)</li>
                      <li><strong>Retro:</strong> Razer Book 13 - This is used to monitor chat and also a backup to do retro gaming if the game isn't intense. I also use this to auto-lurk on streams using my <a href="https://lurker.zemaxi.com"><span className="highlight">Lurker Tool</span></a></li>
                      <li><strong>Phone:</strong> Samsung S25 Ultra (1TB) - This is in case I ever stream mobile games or emulated games that run better on my phone.</li>
                    </ul>
                  </div>

                  <div className="setup-category">
                    <h3>💻 <span className="highlight">Software</span></h3>
                    <ul>
                      <li><strong>Streaming:</strong> OBS Studio</li>
                      <li><strong>Automation:</strong> Streamer.bot</li>
                      <li><strong>Multi-streaming:</strong> Aitum Multistream Plugin</li>
                      <li><strong>Coding:</strong> Windsurf / VS Code </li>
                      <li><strong>Image Editing:</strong> Adobe Photoshop 2025 / Adobe Illustrator 2025</li>
                      <li><strong>Video Editing:</strong> Adobe Premiere Pro 2025 / After Effects 2025</li>
                      <li><strong>Audio Editing:</strong> Audacity</li>

                    </ul>
                  </div>

                  <div className="setup-category">
                    <h3>🎙️ <span className="highlight">Equipment</span></h3>
                    <ul>
                      <li><strong>Microphone:</strong> Fifine AM8 XLR/USB Dynamic</li>
                      <li><strong>Headphones:</strong> SteelSeries Arctic Pro Wireless</li>
                      <li><strong>Audio Interface:</strong> Fifine SC3</li>
                      <li><strong>Capture Card:</strong> Avermedia Live Gamer ULTRA 2.1 & Avermedia Live Gamer Extreme 3 (Backup)</li>
                      <li><strong>Webcam:</strong> None (I'm shy)</li>
                      <li><strong>Main Monitor:</strong> AORUS FO27Q3 27" 1440p QD-OLED (360Hz)</li>
                      <li><strong>Secondary Monitors:</strong> 2x Asus TUF Gaming VG27AQ 27" 1440p (160Hz)</li>
                      <li><strong>Keyboard & Mouse:</strong> Logitech MK850 Multi-Device Wireless Keyboard and Mouse Combo (I don't game on K&M)</li>
                      <li><strong>Controller:</strong>PS5 DualSense OR DualSense Edge</li>
                      <li><strong>Stream Deck:</strong> Samsung Note 9 - Used with the Elgato Stream Deck app to control my stream.</li>
                    </ul>
                  </div>

                  <div className="setup-category dual-pc-full-width">
                    <h3>🖥️ <span className="highlight">Triple PC Setup</span></h3>
                    <div className="triple-pc-setup">
                      <div className="pc-specs">
                        <h4>🎮 PC 1 (YouTube Streaming)</h4>
                        <ul>
                          <li><strong>Brand:</strong> Minisforum AI X1 Pro</li>
                          <li><strong>OS:</strong> Windows 11 Pro</li>
                          <li><strong>CPU:</strong> AMD Ryzen 9 AI HX 370</li>
                          <li><strong>GPU:</strong> Radeon 890M (Integrated)</li>
                          <li><strong>RAM:</strong> 96GB DDR5</li>
                          <li><strong>Storage:</strong> 2TB NVMe</li>
                          <li><strong>Purpose:</strong> Streaming to YouTube</li>
                        </ul>
                      </div>
                      <div className="pc-specs">
                        <h4>💻 PC 2 (Twitch & Kick Streaming)</h4>
                        <ul>
                          <li><strong>Brand:</strong> Custom Build</li>
                          <li><strong>OS:</strong> Windows 11 Pro</li>
                          <li><strong>CPU:</strong> Intel Core i5 9400F</li>
                          <li><strong>GPU:</strong> NVIDIA RTX 3060 Ti</li>
                          <li><strong>RAM:</strong> 64GB DDR4</li>
                          <li><strong>Storage:</strong> 2TB NVMe</li>
                          <li><strong>Purpose:</strong> Streaming to Twitch & Kick</li>
                        </ul>
                      </div>
                      <div className="pc-specs">
                        <h4>🕹️ PC 3 (Gaming)</h4>
                        <ul>
                          <li><strong>Brand:</strong> Razer Blade 17 Pro (2020)</li>
                          <li><strong>OS:</strong> Windows 11 Pro</li>
                          <li><strong>CPU:</strong> Intel Core i7 9750H</li>
                          <li><strong>GPU:</strong> NVIDIA RTX 2060</li>
                          <li><strong>RAM:</strong> 16GB DDR4</li>
                          <li><strong>Storage:</strong> 1TB NVMe</li>
                          <li><strong>Purpose:</strong> PC Gaming (Hardly used)</li>
                        </ul>
                      </div>
                    </div>
                    <div className="obs-communication">
                      <h4>🔗 Streaming Communication</h4>
                      <p><strong>Gaming Console/PC:</strong> Depending on where I am gaming from. The Avermedia capture card is plugged in to either the PS5 Pro or Razer Laptop to capture gameplay footage to PC 1. An audio extractor is used to capture the audio from the Gaming Console/PC to the SteelSeries Pro Wireless DAC's SPDIF port. The DAC is also connected to PC 2 via USB so that I can hear both the Gaming device audio and also the audio from OBS Studio and Streamer.bot.</p> 
                      <p><strong>PC 1 Encoding:</strong> PC 1 uses the AMD H.265 HEVC encoder to stream 1440p HDR quality to YouTube.</p>
                      <p><strong>PC 1 → PC 2:</strong> For PC 2 to also get the captured gameplay, the Teleport plugin is used to send a video output from PC 1's OBS Studio, which goes through the network to PC 2's OBS Studio.</p>
                      <p><strong>PC 2 Encoding:</strong> PC 2 uses the Nvidia H.264 encoder to stream 1080p quality to both Twitch & Kick. Aitum Multistream plugin is used to stream to both platforms at the same time. A HDR to SDR LUT is used to convert the HDR content for Twitch/Kick.</p>
                      <p><strong>PC 2 Features:</strong> PC 2 has streamer.bot connected and this is where all the memes are stored.</p>
                      <p><strong>Monitoring:</strong> I use my Razer Book 13 to monitor both Twitch, YouTube and Kick chat. The secondary monitors has the OBS Studio showing for PC 1 and PC 2 so I know YouTube and Twitch/Kick streaming is still going.</p>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}